import formatUnicorn from './utils/formatUnicorn'

export const defaultDescription = "As a PGA Professional he has golf coaching qualifications, as well as many more. He now enjoys teaching a vast array of golfer’s from the absolute beginner to elite player level. His coaching philosophies centre around optimising an individual’s movement to fit to their own unique physical characteristics and identity. By teaching the golfer to effectively use the correct body parts to increase speed whilst maintaining control, this gives them the best chance possible of performing a repetitive action."

const defaultDay = [[8, 16]]

const displayCurrencies = {
  EUR: '€',
  GBP: '£',
  USD: '$',
}

const displayCurrency = (currency = '') => { 
  return currency in displayCurrencies ? displayCurrencies[currency] : currency 
}

export const defaultWorkingHours = {
  location_id: null,
  repeat: 2,
  type: 0,
  days: {
    su: { time: defaultDay },
    mo: { time: defaultDay },
    tu: { time: defaultDay },
    we: { time: defaultDay },
    th: { time: defaultDay },
    fr: { time: defaultDay },
    sa: { time: defaultDay },
  },
}

export const defaultWorkingDays = {
  su: true,
  mo: true,
  tu: true,
  we: true,
  th: true,
  fr: true,
  sa: true,
}

export const lessonTypes = {
  PRIVATE30: 'Private30',
  PRIVATE60: 'Private60',
  PLAYINGLESSON: 'PlayingLesson',
  CLUBFITTING: 'ClubFitting',
  PUTTERFITTING: 'PutterFitting',
  TRACKMANGAPPING: 'TrackmanGapping',
}


export const durations = [30, 45, 60, 90, 120, 180, 240].map(item => ({ label: item, value: item }))

export const priceGroup = {
  id: 1,
  price: '',
  priceGroup: '',
}

export const customLesson = {
  custom: true,
  weight: undefined,
  enabled: true,
  type: undefined,
  title: undefined,
  description: undefined,
  currency: undefined,
  prices: [
    priceGroup,
  ],
  duration: undefined,
  editableDuration: true,
}

const private30 = {
  weight: 1,
  enabled: false,
  type: lessonTypes.PRIVATE30,
  title: '30 min private lesson',
  description: 'Lessons will take place on our driving range or other coaching area. Our professional(s) will commit to what you have asked to learn in a fun and relaxed manner, leaving you/everybody with take home exercises for continued learning in your chosen area.',
  currency: '',
  prices: [
    priceGroup,
  ],
  duration: 30,
  editableDuration: false,
}

const private60 = {
  weight: 2,
  enabled: false,
  type: lessonTypes.PRIVATE60,
  title: '60 min private lesson',
  description: 'Lessons will take place on our driving range or other coaching area. Our professional(s) will commit to what you have asked to learn in a fun and relaxed manner, leaving you/everybody with take home exercises for continued learning in your chosen area.',
  currency: '',
  prices: [
    priceGroup,
  ],
  duration: 60,
  editableDuration: false,
}

const playingLesson = {
  weight: 3,
  enabled: false,
  type: lessonTypes.PLAYINGLESSON,
  title: 'Playing lesson',
  description: 'Playing lessons are the road to success! In the playing lesson your golf pro will focus less on the swing and more about how you apply that swing to the golf course. Lessons help you understand the playing strategy, improve your course management skills, encourage better club selection and ultimately achieve your best score.',
  currency: '',
  prices: [
    priceGroup,
  ],
  duration: '',
  editableDuration: true,
}

const clubFitting = {
  weight: 4,
  enabled: false,
  type: lessonTypes.CLUBFITTING,
  title: 'Club fitting',
  description: 'Ideal for single club fittings such as a Driver, wood, hybrid or wedge fitting session.',
  currency: '',
  prices: [
    priceGroup,
  ],
  duration: '',
  editableDuration: true,
}

const putterFitting = {
  weight: 5,
  enabled: false,
  type: lessonTypes.PUTTERFITTING,
  title: 'Putter fitting',
  description: '',
  currency: '',
  prices: [
    priceGroup,
  ],
  duration: '',
  editableDuration: true,
}

const trackmanGapping = {
  weight: 6,
  enabled: false,
  type: lessonTypes.TRACKMANGAPPING,
  title: 'TrackMan Gapping',
  description: '',
  currency: '',
  prices: [
    priceGroup,
  ],
  duration: '',
  editableDuration: true,
}

export const defaultLessons = [
  private30,
  private60,
  playingLesson,
  clubFitting,
  putterFitting,
  trackmanGapping,
]

export const packageTypes = {
  PRIVATE_5_FOR_4_30_MIN: 'PRIVATE_5_FOR_4_30_MIN',
  PRIVATE_6_FOR_6_30_MIN: 'PRIVATE_6_FOR_6_30_MIN',
  PRIVATE_5_FOR_4_60_MIN: 'PRIVATE_5_FOR_4_60_MIN',
  PRIVATE_6_FOR_6_60_MIN: 'PRIVATE_6_FOR_6_60_MIN',
  GIFT_CARD_50: 'GIFT_CARD_50',
  GIFT_CARD_100: 'GIFT_CARD_100',
  GIFT_CARD_150: 'GIFT_CARD_150',
  GIFT_CARD_200: 'GIFT_CARD_200',
  GIFT_CARD_300: 'GIFT_CARD_300',
}

const package1 = {
  weight: 1,
  enabled: false,
  type: packageTypes.PRIVATE_5_FOR_4_30_MIN,
  title: '5 lessons for the price of 4 (30 min lesson)',
  description: '',
  currency: '',
  price: undefined,
  editablePrice: true,
  requireProduct: lessonTypes.PRIVATE30,
}

const package2 = {
  weight: 2,
  enabled: false,
  type: packageTypes.PRIVATE_6_FOR_6_30_MIN,
  title: '6 lessons for the price of 5 (30 min lesson)',
  description: '',
  currency: '',
  price: undefined,
  editablePrice: true,
  requireProduct: lessonTypes.PRIVATE30,
}

const package3 = {
  weight: 3,
  enabled: false,
  type: packageTypes.PRIVATE_5_FOR_4_60_MIN,
  title: '5 lessons for the price of 4 (60 min lesson)',
  description: '',
  currency: '',
  price: undefined,
  editablePrice: true,
  requireProduct: lessonTypes.PRIVATE60,
}
const package4 = {
  weight: 4,
  enabled: false,
  type: packageTypes.PRIVATE_6_FOR_6_60_MIN,
  title: '6 lessons for the price of 5 (60 min lesson)',
  description: '',
  currency: '',
  price: undefined,
  editablePrice: true,
  requireProduct: lessonTypes.PRIVATE60,
}

const giftCard = {
  weight: 5,
  enabled: false,
  type: packageTypes.GIFT_CARD_50,
  title: 'Gift card {currency}{price}',
  description: '{firstName} {lastName} gift cards make a unique golfing gift. \n\n Gift cards can be redeemed against numerous golf tuition services. Just use the voucher code while booking lessons online or contact {firstName} directly.',
  currency: '',
  price: '50',
  editablePrice: false,
  requireProduct: null,
}

export const customPackage = {
  custom: true,
  weight: undefined,
  enabled: true,
  type: undefined,
  title: undefined,
  description: undefined,
  currency: undefined,
  price: undefined,
  editablePrice: true,
  requireProduct: null,
}

export const defaultPackages = proCurrency => (proFirstName, proLastName) => ([
  package1,
  package2,
  package3,
  package4,
  {
    ...giftCard, price: 50,
  },
  {
    ...giftCard, price: 100, weight: 6, type: packageTypes.GIFT_CARD_100,
  },
  {
    ...giftCard, price: 150, weight: 7, type: packageTypes.GIFT_CARD_150,
  },
  {
    ...giftCard, price: 200, weight: 8, type: packageTypes.GIFT_CARD_200,
  },
  {
    ...giftCard, price: 300, weight: 9, type: packageTypes.GIFT_CARD_300,
  },
].map(item => ({
  ...item,
  currency: proCurrency,
  title: formatUnicorn(item.title, { currency: displayCurrency(proCurrency), price: item.price }),
  description: formatUnicorn(item.description, { firstName: proFirstName, lastName: proLastName }),
})))

export const groupLessonOptions = [
  "I Don't have group Lessons",
  "Within the next 2 months",
  "Within the next 4 months",
  "Within the next 6 months",
  "Within the next 12 months",
].map(item => ({ value: item, label: item }))


export const formStates = {
  PROFILE: 'PROFILE',
  HOURS: 'HOURS',
  LESSONS: 'LESSONS',
  PACKAGES: 'PACKAGES',
  GROUPS: 'GROUPS',
  WEBSITE: 'WEBSITE',
}



// WEBPACK FOOTER //
// ./src/const.js